module.exports = __webpack_public_path__ + "static/img/card_bg_eng@2x.0ef93e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greenchannel/card_bg_eng@2x.png
// module id = 45eO
// module chunks = 1